var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5L6.75 2.25H3.75C3.3 2.25 3 2.55 3 3C3 3.45 3.3 3.75 3.75 3.75H5.25H12.75H14.25C14.7 3.75 15 3.45 15 3C15 2.55 14.7 2.25 14.25 2.25H11.25L10.5 1.5H7.5ZM3.75 5.25V15C3.75 15.825 4.425 16.5 5.25 16.5H12.75C13.575 16.5 14.25 15.825 14.25 15V5.25H3.75ZM6.75 6.75C7.2 6.75 7.5 7.05 7.5 7.5V14.25C7.5 14.7 7.2 15 6.75 15C6.3 15 6 14.7 6 14.25V7.5C6 7.05 6.3 6.75 6.75 6.75ZM11.25 6.75C11.7 6.75 12 7.05 12 7.5V14.25C12 14.7 11.7 15 11.25 15C10.8 15 10.5 14.7 10.5 14.25V7.5C10.5 7.05 10.8 6.75 11.25 6.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.08cae61c7c3ccc94bf2ba8096e272589.svg";
export { ForwardRef as ReactComponent };